<template>
  <div class="flex flex-col h-screen pb-safe overflow-hidden">
    <top-bar v-if="!isMobile">
      <template #center>
        <top-menu />
      </template>
    </top-bar>
    <template v-else>
      <top-bar-mobile>
        <template #left>
          <top-menu />
        </template>
        <template #right>
          <div class="flex items-center">
            <div class="relative cursor-pointer mx-2" @click="showNotifications = true">
              <div v-if="notificationsAmount > 0" class="absolute z-10 right-0 top-[-0.2rem]">
                <l-badge
                  class="cursor-pointer"
                  mode="alert"
                  type="small"
                  :value="notificationsAmount"
                />
              </div>
              <l-lottie
                ref="bellAnim"
                width="1.8rem"
                height="1.8rem"
                :animation-data="bellAnimation"
                :loop="true"
                :auto-play="false"
              />
            </div>
            <l-button
              size="medium"
              icon="hamburger-3-lines"
              type="text"
              color="white"
              @click="showMenu = true"
            />
          </div>
        </template>
      </top-bar-mobile>
      <side-menu :open="showMenu" @close="showMenu = false" />
      <notifications :open="showNotifications" @close="showNotifications = false" />
    </template>

    <router-view v-slot="{ Component }">
      <keep-alive>
        <component :is="Component" />
      </keep-alive>
    </router-view>
  </div>
</template>

<script setup lang="ts">
import { useIdle } from '@vueuse/core'
import { ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'

import { LBadge, LButton, LLottie } from '@last/core-ui/paprika'

import bellAnimation from '@/assets/notification-V4.json'
import Notifications from '@/components/Notifications.vue'
import SideMenu from '@/components/SideMenu.vue'
import TopBar from '@/components/TopBar.vue'
import TopBarMobile from '@/components/TopBarMobile.vue'
import TopMenu from '@/components/TopMenu.vue'
import { useHome } from '@/composables/useHome'
import { useNotifications } from '@/composables/useNotifications'
import { useConfigStore } from '@/store/config'
import { isMobile } from '@/utils/device-type'

const { config } = useConfigStore()
const { activeMenu } = useHome()
const router = useRouter()
const route = useRoute()
const { amount: notificationsAmount } = useNotifications()

const showMenu = ref(false)
const showNotifications = ref(false)

router.afterEach(route => {
  if (route.matched[0].name === 'pos') {
    activeMenu.value = route.name as string
  }
})

const DEFAULT_TIMEOUT = 3600 // 1 hour
const { idle, reset } = useIdle((config.timeoutSeconds ?? DEFAULT_TIMEOUT) * 1000)

watch(idle, isIdle => {
  if (route.name === 'checkout' || route.name === 'checkout2') {
    reset()
  } else if (isIdle && route.name !== 'employees') {
    router.push({ name: 'employees' })
  }
})
</script>
